
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { AppCommonModule } from '../common.module';
import { DashboardViewComponent } from '../components/views/dashboard/view-dashboard.component';
import { ShiftComponent } from './shift.component';

@Component({
  selector: 'app-shift-page',
  templateUrl: './shift.page.html',
  styleUrls: ['./shift.page.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    AppCommonModule,
    DashboardViewComponent,
    ShiftComponent,
  ],
})
export class ShiftPage {

}
